export default __webpack_public_path__ + "static/media/icon-padlock.52ec8b51.svg";